export default __webpack_public_path__ + "static/media/checked.8abf303f.svg";